mutation DeleteTags($ids: [ID!]!) {
  deleteTags(ids: $ids) {
    id
  }
}
